import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Button, Grid, Spinner } from 'gu-ui-kit'
import styles from 'components/ShowMoreButton/ShowMoreButton.module.scss'

const ShowMoreButton = ({
  onClick,
  loading = false,
  color = 'Label-GU-Primary',
  className,
  children,
  showFromTo = false,
  current,
  total,
}) => {
  const { t } = useTranslation()

  if (total !== undefined && (!current || current >= total)) {
    return null
  }

  return (
    <div className={clsx(styles['pagination'], className)}>
      {showFromTo && !!total && (
        <span className={styles['pagination__from-to']}>
          {`1 – ${current} ${t('common::pagination.of')} ${total}`}
        </span>
      )}
      <Grid
        alignItems={'center'}
        justifyContent={'center'}
        className={styles['show-more-wrapper']}
      >
        <Button
          size={'m'}
          onClick={onClick}
          variant={'secondary'}
          color={color}
          startIcon={
            loading ? (
              <Spinner
                width={16}
                color={'inherit'}
              />
            ) : null
          }
        >
          {children || t('common::pagination.show_more')}
        </Button>
      </Grid>
    </div>
  )
}

ShowMoreButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  color: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  showFromTo: PropTypes.bool,
  current: PropTypes.number,
  total: PropTypes.number,
}

export default ShowMoreButton
